import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import { Link, useParams, withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Row,
  TabContent,
  Badge,
  Table,
  TabPane,
  UncontrolledCollapse,
  UncontrolledDropdown,
  Modal,
  Form,
  ModalHeader,
  ModalBody,
  FormFeedback,
  ModalFooter,
  Button,
} from "reactstrap";
import classnames from "classnames";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay } from "swiper";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//Images
import profileBg from "../../../assets/images/profile-bg.jpg";
import avatar1 from "../../../assets/images/users/avatar-1.jpg";
import avatar2 from "../../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../../assets/images/users/avatar-4.jpg";
import avatar5 from "../../../assets/images/users/avatar-5.jpg";
import avatar6 from "../../../assets/images/users/avatar-6.jpg";
import avatar7 from "../../../assets/images/users/avatar-7.jpg";
import avatar8 from "../../../assets/images/users/avatar-8.jpg";
import dummyImg from "../../../assets/images/users/user-dummy-img.jpg";

import smallImage2 from "../../../assets/images/small/img-2.jpg";
import smallImage3 from "../../../assets/images/small/img-3.jpg";
import smallImage4 from "../../../assets/images/small/img-4.jpg";
import smallImage5 from "../../../assets/images/small/img-5.jpg";
import smallImage6 from "../../../assets/images/small/img-6.jpg";
import smallImage7 from "../../../assets/images/small/img-7.jpg";
import smallImage9 from "../../../assets/images/small/img-9.jpg";

import axiosInstance from "../../../axiosConfig";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../Components/Common/Loader";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

const ChauffeursDetail = (props) => {
  const dispatch = useDispatch();
  const [selectDriver, setSelectDriver] = useState({});

  const { chauffeurs, isChauffeurCreated, isChauffeurSuccess, error } =
    useSelector((state) => ({
      chauffeurs: state.Chauffeur.chauffeurs,
      isChauffeurCreated: state.Chauffeur.isChauffeurCreated,
      isChauffeurSuccess: state.Chauffeur.isChauffeurSuccess,
      error: state.Chauffeur.error,
    }));

  //Début code pour get le chauffeur sélectionné
  const chauffeurId = useParams("id");
  // console.log("numcon", chauffeurId.id);
  const url = process.env.REACT_APP_API_URL;
  const token = JSON.parse(localStorage.getItem("authUser"))
    ? JSON.parse(localStorage.getItem("authUser")).access
    : null;
  // if ( token )
  //   axios.defaults.headers.common[ "Authorization" ] = "Bearer " + token;
  // Fonction pour calculer le revenu total
  const calculerRevenuTotal = (data) => {
    return data.reduce((total, item) => {
      return total + item.revenu_mensuel;
    }, 0);
  };

  const [selectchauffeur, setSelectChauffeur] = useState({});
  const [chauffeurCourses, setChauffeurCourses] = useState({});
  const [modal, setModal] = useState(false);
  const [isEditPhone, setIsEditPhone] = useState(false);

  // Classes attribuables. « Confort » ne s'obtient que par ici : le formulaire
  // mobile ne la propose pas, et le serveur défait toute tentative d'un
  // chauffeur de se l'attribuer lui-même.
  const [classesEngin, setClassesEngin] = useState([]);
  const [classeChoisie, setClasseChoisie] = useState("");
  const [enregistrementClasse, setEnregistrementClasse] = useState(false);

  // L'engin du chauffeur, tel que `driverdetail` le renvoie.
  const enginChauffeur = Array.isArray(selectchauffeur?.engins)
    ? selectchauffeur.engins[0]
    : selectchauffeur?.engins;

  const libelleEngin = enginChauffeur?.typeEngin
    ? `${enginChauffeur.typeEngin.designation}${
        enginChauffeur.typeEngin.classe
          ? ` (${enginChauffeur.typeEngin.classe})`
          : ""
      }`
    : null;

  const fetchDataDetail = async () => {
    try {
      const driverDetail = await axiosInstance.get(
        `/driverdetail/?id=${chauffeurId.id}/`
      );
      setSelectChauffeur(driverDetail.data.data);
      console.log(driverDetail);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchDataDetail();
  }, [chauffeurId, url]);

  useEffect(() => {
    const chargerClasses = async () => {
      try {
        const reponse = await axiosInstance.get(`/allengin`);
        setClassesEngin(reponse?.data?.data ?? []);
      } catch (err) {
        console.error("Erreur de récupération des types d'engin: ", err);
      }
    };

    chargerClasses();
  }, []);

  useEffect(() => {
    if (enginChauffeur?.type_engin_id) {
      setClasseChoisie(String(enginChauffeur.type_engin_id));
    }
  }, [enginChauffeur?.type_engin_id]);

  /**
   * Attribue une classe au chauffeur.
   *
   * La climatisation suit côté serveur : la laisser diverger de la classe
   * ferait défaire l'attribution au prochain enregistrement du chauffeur.
   */
  const attribuerClasse = async () => {
    if (!classeChoisie || !selectchauffeur?.user_id) return;

    setEnregistrementClasse(true);

    try {
      await axiosInstance.put(
        `/driverclasseengin/?id=${selectchauffeur.user_id}`,
        { type_engin_id: Number(classeChoisie) }
      );
      toast.success(props.t("Classe du véhicule mise à jour"), {
        autoClose: 3000,
      });
      fetchDataDetail();
    } catch (err) {
      toast.error(
        err?.response?.data?.error ||
          props.t("Échec de la mise à jour de la classe"),
        { autoClose: 4000 }
      );
    }

    setEnregistrementClasse(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const revenusDetail = await axiosInstance.get(
          `/revenuconducteur/?id=${chauffeurId.id}/`
        );
        setChauffeurCourses(revenusDetail.data.data);
        // console.log(revenusDetail);
      } catch (err) {
        console.log("Echec de récupération des courses du chauffeur ", err);
      }
    };
    fetchData();
  }, [chauffeurId, url]);

  useEffect(() => {
    console.log("selectchauffeur", selectchauffeur);
    // console.log("selectchauffeur.length", Object.keys(selectchauffeur).length);
    if (!isEmpty(selectchauffeur)) setSelectChauffeur(selectchauffeur);
  }, [selectchauffeur]);

  SwiperCore.use([Autoplay]);

  const [activeTab, setActiveTab] = useState("1");
  const [activityTab, setActivityTab] = useState("1");

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const toggleActivityTab = (tab) => {
    if (activityTab !== tab) {
      setActivityTab(tab);
    }
  };

   function formatDate(date) {
     const dateObject = new Date(date).toLocaleDateString("fr-FR", {
       year: "numeric",
       month: "long",
       day: "numeric",
       hour: "2-digit",
       minute: "2-digit",
       second: "2-digit",
       timeZoneName: "short",
     });
     return dateObject;
   }

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      first_name: (selectchauffeur && selectchauffeur.first_name) || "",
      last_name: (selectchauffeur && selectchauffeur.last_name) || "",
      email: (selectchauffeur && selectchauffeur.email) || "",
      telephone: (selectchauffeur && selectchauffeur.telephone) || "",
      type_conducteur:
        (selectchauffeur && selectchauffeur.type_conducteur) || "Conducteur",
      cg: (selectchauffeur && selectchauffeur.cg) || "",
      code_parrain: (selectchauffeur && selectchauffeur.code_parrain) || "",
      password: (selectchauffeur && selectchauffeur.password) || "",
    },
    validationSchema: Yup.object({
      first_name:
        !isEditPhone &&
        Yup.string().required(props.t("Veuillez renseigner les prénoms")),
      last_name:
        !isEditPhone &&
        Yup.string().required(props.t("Veuillez renseigner le nom")),
      email:
        !isEditPhone &&
        Yup.string().required(props.t("Veuillez renseigner l'email")),
      telephone: Yup.string().required(
        props.t("Veuillez renseigner le numero de téléphone")
      ),
      type_conducteur:
        !isEditPhone &&
        Yup.string().required(
          props.t("Veuillez renseigner le type de conducteur")
        ),
      cg:
        !isEditPhone &&
        Yup.string().required(props.t("Veuillez renseigner la carte grise")),
      password:
        !isEditPhone &&
        Yup.string().required(props.t("Veuillez renseigner le mot de passe")),
    }),
    onSubmit: async (values) => {
      // console.log("isEditPhone: ", isEditPhone);
      // console.log("isEditPhone: ", isEditPhone);

      if (!isEditPhone) {
        const updateChauffeur = {
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
        };

        // console.log("updateChauffeur:", updateChauffeur);
        // console.log("selectchauffeur.user_id:", selectchauffeur.user_id);

        try {
          const data = axiosInstance
            .put(
              `/driverinfoupdate/?id=${selectchauffeur.user_id}/`,
              updateChauffeur
            )
            .then((response) => {
              // dispatch(onUpdateChauffeur(updateChauffeur));
              validation.resetForm();
              toast.success(props.t("Chauffeur modifié avec succès"), {
                autoClose: 3000,
              });
            })
            .catch((error) => {
              toast.error(props.t("Echec de la modification du Chauffeur"), {
                autoClose: 3000,
              });
            });

          // window.location.reload(true);
        } catch (err) {
          console.log(err);
          toast.error(props.t("Echec de la modification du Chauffeur"), {
            autoClose: 2000,
          });
        }
      } else {
        const updatePhoneChauffeur = {
          newTelephone: values.telephone,
        };

        console.log("updatePhoneChauffeur:", updatePhoneChauffeur);
        try {
          const data = axiosInstance
            .put(
              `/driverchangephone/?id=${selectchauffeur.user_id}/`,
              updatePhoneChauffeur
            )
            .then((response) => {
              // dispatch(onUpdateChauffeur(updateChauffeur));
              validation.resetForm();
              toast.success(
                props.t("Numero de téléphone du chauffeur modifié avec succès"),
                { autoClose: 3000 }
              );
            });
        } catch (error) {
          console.error(
            "Echec de la modification du numero de téléphone du Chauffeur ",
            error
          );
          toast.error(
            props.t(
              "Echec de la modification du numero de téléphone du Chauffeur"
            ),
            { autoClose: 3000 }
          );
        }
      }

     await  fetchDataDetail();
      setModal(false);
    },
  });

  document.title = "Détails Chauffeurs | Takci";

  return (
    <React.Fragment>
      <div className="page-content">
        <BreadCrumb
          title={props.t("Détails Chauffeur")}
          pageTitle="Chauffeurs"
          pageTitleLink="/chauffeur"
        />

        <Container fluid>
          {selectchauffeur && Object.keys(selectchauffeur).length !== 0 ? (
            <>
              <div className="profile-foreground position-relative mx-n4 mt-n4">
                <div className="profile-wid-bg">
                  <img src={profileBg} alt="" className="profile-wid-img" />
                </div>
              </div>
              <div className="pt-4 mb-4 mb-lg-3 pb-lg-4 profile-wrapper">
                <Row className="g-4">
                  <div className="col-auto">
                    <div className="avatar-lg">
                      <img
                        src={dummyImg}
                        alt="user-img"
                        className="img-thumbnail rounded-circle"
                      />
                    </div>
                  </div>

                  <Col>
                    <div className="p-2">
                      <h3 className="text-white mb-1">
                        {selectchauffeur.last_name || (
                          <Badge color="danger">Non renseignée</Badge>
                        )}{" "}
                        {selectchauffeur.first_name || (
                          <Badge color="danger">Non renseignée</Badge>
                        )}
                      </h3>
                      <p className="text-white-75">Livreur</p>
                      <div className="hstack text-white-50 gap-1">
                        <div className="me-2">
                          <i className="ri-map-pin-user-line me-1 text-white-75 fs-16 align-middle"></i>
                          {selectchauffeur.ville || (
                            <Badge color="danger">Non renseignée</Badge>
                          )}
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col xs={12} className="col-lg-auto order-last order-lg-0">
                    <Row className="text text-white-50 text-center">
                      <Col lg={6} xs={4}>
                        <div className="p-2">
                          <h4 className="text-white mb-1">
                            {Object.keys(chauffeurCourses).length}
                          </h4>
                          <p className="fs-14 mb-0">Courses</p>
                        </div>
                      </Col>
                      <Col lg={6} xs={4}>
                        <div className="p-2">
                          <h4 className="text-white mb-1">
                            {Object.keys(chauffeurCourses).length > 0 &&
                              calculerRevenuTotal(chauffeurCourses)}
                          </h4>
                          <p className="fs-14 mb-0">Gains</p>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </>
          ) : (
            <>
              <div className="text-center my-3">
                <Loader style={{ color: "#014c94" }} />
              </div>
            </>
          )}

          <Row>
            <Col lg={12}>
              <div>
                <div className="d-flex profile-wrapper">
                  <Nav
                    pills
                    className="animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1"
                    role="tablist"
                  >
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: activeTab === "1" })}
                        onClick={() => {
                          toggleTab("1");
                        }}
                      >
                        <i className="ri-airplay-fill d-inline-block d-md-none"></i>{" "}
                        <span className="d-none d-md-inline-block">
                          Infos Personnelles
                        </span>
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: activeTab === "2" })}
                        onClick={() => {
                          toggleTab("2");
                        }}
                      >
                        <i className="ri-folder-4-line d-inline-block d-md-none"></i>{" "}
                        <span className="d-none d-md-inline-block">
                          Documents
                        </span>
                      </NavLink>
                    </NavItem>
                    
                  </Nav>
                  <div className="flex-shrink-0">
                    <Link
                      to="#"
                      disabled={selectchauffeur && Object.keys(selectchauffeur).length !== 0}
                      style={{ background: "#002437", color: "white" }}
                      className="btn"
                      onClick={() => {
                        setModal(true);
                      }}
                    >
                      <i className="ri-edit-box-line align-bottom"></i>
                      {props.t("Edit")}
                    </Link>
                  </div>
                </div>

                <TabContent activeTab={activeTab} className="pt-4">
                  <TabPane tabId="1">
                    <Row>
                      <Col xxl={12}>
                        <Card>
                          <CardBody>
                            <h5 className="card-title mb-3">Infos</h5>

                            {/* Véhicule et classe. La classe décide des
                                courses que reçoit le chauffeur : Économique,
                                Basique ou Confort. */}
                            <div className="border rounded p-3 mb-3">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <span className="text-muted">
                                  {props.t("Véhicule")}
                                </span>
                                <strong>
                                  {libelleEngin || (
                                    <Badge color="danger">
                                      Aucun véhicule
                                    </Badge>
                                  )}
                                </strong>
                              </div>

                              {enginChauffeur ? (
                                <>
                                  <div className="d-flex gap-2">
                                    <Input
                                      type="select"
                                      value={classeChoisie}
                                      onChange={(e) =>
                                        setClasseChoisie(e.target.value)
                                      }
                                      disabled={enregistrementClasse}
                                    >
                                      {classesEngin.map((type) => (
                                        <option key={type.id} value={type.id}>
                                          {type.designation}
                                          {type.classe
                                            ? ` (${type.classe})`
                                            : ""}
                                        </option>
                                      ))}
                                    </Input>

                                    <Button
                                      color="primary"
                                      onClick={attribuerClasse}
                                      disabled={
                                        enregistrementClasse ||
                                        String(
                                          enginChauffeur.type_engin_id
                                        ) === classeChoisie
                                      }
                                    >
                                      {enregistrementClasse
                                        ? props.t("Envoi...")
                                        : props.t("Appliquer")}
                                    </Button>
                                  </div>

                                  <small className="text-muted d-block mt-2">
                                    {props.t(
                                      "La climatisation suit la classe attribuée. Impossible pendant une course."
                                    )}
                                  </small>
                                </>
                              ) : null}
                            </div>

                            {selectchauffeur &&
                            Object.keys(selectchauffeur).length !== 0 ? (
                              <>
                                <div className="table-responsive">
                                  <Table className="table-borderless mb-0">
                                    <tbody>
                                      <tr>
                                        <th className="ps-0" scope="row">
                                          {props.t("Full Name")}:
                                        </th>
                                        <td className="text-muted">
                                          {selectchauffeur.last_name || (
                                            <Badge color="danger">
                                              Non renseignée
                                            </Badge>
                                          )}{" "}
                                          {selectchauffeur.first_name || (
                                            <Badge color="danger">
                                              Non renseignée
                                            </Badge>
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th className="ps-0" scope="row">
                                          {props.t("Phone number")}:
                                        </th>
                                        <td className="text-muted">
                                          {(selectchauffeur.telephone && (
                                            <>
                                              <a
                                                href={`tel: ${selectchauffeur.telephone}`}
                                              >
                                                {selectchauffeur.telephone}
                                              </a>
                                              <Link
                                                to="#"
                                                className="text-warning d-inline-block"
                                                onClick={() => {
                                                  setIsEditPhone(true);
                                                  setModal(true);
                                                }}
                                              >
                                                <i className="ri-pencil-fill align-top"></i>
                                              </Link>
                                            </>
                                          )) || (
                                            <Badge color="danger">
                                              Non renseignée
                                            </Badge>
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th className="ps-0" scope="row">
                                          {props.t("Email")}:
                                        </th>
                                        <td className="text-muted">
                                          {(selectchauffeur.email && (
                                            <a
                                              href={`mailto: ${selectchauffeur.email}`}
                                            >
                                              {selectchauffeur.email}
                                            </a>
                                          )) || (
                                            <Badge color="danger">
                                              Non renseignée
                                            </Badge>
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th className="ps-0" scope="row">
                                          {props.t("Joining Date")}
                                        </th>
                                        <td className="text-muted">
                                          {(selectchauffeur.created_at &&
                                            formatDate(
                                              selectchauffeur.created_at
                                            )) || (
                                            <Badge color="danger">
                                              Non renseignée
                                            </Badge>
                                          )}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="text-center my-3">
                                  <Loader style={{ color: "#014c94" }} />
                                </div>
                              </>
                            )}
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </TabPane>

                  <TabPane tabId="2">
                    <Card>
                      <CardBody>
                        <div className="d-flex align-items-center mb-4">
                          <h5 className="card-title flex-grow-1 mb-0">
                            Documents
                          </h5>
                        </div>
                        <Row>
                          <Col lg={12}>
                            <div className="table-responsive">
                              {selectchauffeur &&
                              Object.keys(selectchauffeur).length !== 0 ? (
                                <>
                                  <Table className="table-borderless align-middle mb-0">
                                    <thead className="table-light">
                                      <tr>
                                        <th scope="col">Fichiers</th>
                                        <th scope="col">Date d'expiration</th>
                                        <th scope="col">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>
                                          <div className="d-flex align-items-center">
                                            <div className="avatar-sm">
                                              <div
                                                className={`avatar-title bg-soft-${
                                                  selectchauffeur.attestation_residence
                                                    ? "primary"
                                                    : "danger"
                                                } text-${
                                                  selectchauffeur.attestation_residence
                                                    ? "primary"
                                                    : "danger"
                                                } rounded fs-20`}
                                              >
                                                <i className="ri-image-2-fill"></i>
                                              </div>
                                            </div>
                                            <div className="ms-3 flex-grow-1">
                                              <h6 className="fs-15 mb-0">
                                                <Link to="#">
                                                  {selectchauffeur.attestation_residence
                                                    ? selectchauffeur.attestation_residence
                                                    : "Pas d'attestation de résidence"}
                                                </Link>
                                              </h6>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          {selectchauffeur.attestation_residence
                                            ? selectchauffeur.attestation_residence
                                            : "Pas de date"}
                                        </td>
                                        <td>
                                          <UncontrolledDropdown
                                            direction="start"
                                            disabled={
                                              !selectchauffeur.attestation_residence
                                            }
                                          >
                                            <DropdownToggle
                                              tag="a"
                                              className="btn btn-light btn-icon"
                                              id="dropdownMenuLink15"
                                              role="button"
                                            >
                                              <i className="ri-equalizer-fill"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                              <DropdownItem>
                                                <i className="ri-pencil-fill me-2 align-middle text-muted" />
                                                Modifier
                                              </DropdownItem>
                                              <DropdownItem>
                                                <i className="ri-eye-fill me-2 align-middle text-muted" />
                                                Visualiser
                                              </DropdownItem>
                                              <DropdownItem>
                                                <i className="ri-download-2-fill me-2 align-middle text-muted" />
                                                Télécharger
                                              </DropdownItem>
                                            </DropdownMenu>
                                          </UncontrolledDropdown>
                                        </td>
                                      </tr>

                                      {/* Permis */}
                                      <tr>
                                        <td>
                                          <div className="d-flex align-items-center">
                                            <div className="avatar-sm">
                                              <div
                                                className={`avatar-title bg-soft-${
                                                  selectchauffeur.permis
                                                    ? "primary"
                                                    : "danger"
                                                } text-${
                                                  selectchauffeur.permis
                                                    ? "primary"
                                                    : "danger"
                                                } rounded fs-20`}
                                              >
                                                <i className="ri-image-2-fill"></i>
                                              </div>
                                            </div>
                                            <div className="ms-3 flex-grow-1">
                                              <h6 className="fs-15 mb-0">
                                                <Link to="#">
                                                  {selectchauffeur.permis
                                                    ? selectchauffeur.permis
                                                    : "Pas de permis"}
                                                </Link>
                                              </h6>
                                            </div>
                                          </div>
                                        </td>

                                        <td>
                                          {selectchauffeur.permis
                                            ? selectchauffeur.permis
                                            : "Pas de date"}
                                        </td>
                                        <td>
                                          <UncontrolledDropdown
                                            direction="start"
                                            disabled={!selectchauffeur.permis}
                                          >
                                            <DropdownToggle
                                              tag="a"
                                              className="btn btn-light btn-icon"
                                              id="dropdownMenuLink15"
                                              role="button"
                                            >
                                              <i className="ri-equalizer-fill"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                              <DropdownItem>
                                                <i className="ri-pencil-fill me-2 align-middle text-muted" />
                                                Modifier
                                              </DropdownItem>
                                              <DropdownItem>
                                                <i className="ri-eye-fill me-2 align-middle text-muted" />
                                                Visualiser
                                              </DropdownItem>
                                              <DropdownItem>
                                                <i className="ri-download-2-fill me-2 align-middle text-muted" />
                                                Télécharger
                                              </DropdownItem>
                                            </DropdownMenu>
                                          </UncontrolledDropdown>
                                        </td>
                                      </tr>

                                      {/* Photo */}
                                      <tr>
                                        <td>
                                          <div className="d-flex align-items-center">
                                            <div className="avatar-sm">
                                              <div
                                                className={`avatar-title bg-soft-${
                                                  selectchauffeur.photo
                                                    ? "primary"
                                                    : "danger"
                                                } text-${
                                                  selectchauffeur.photo
                                                    ? "primary"
                                                    : "danger"
                                                } rounded fs-20`}
                                              >
                                                <i className="ri-image-2-fill"></i>
                                              </div>
                                            </div>
                                            <div className="ms-3 flex-grow-1">
                                              <h6 className="fs-15 mb-0">
                                                <Link to="#">
                                                  {selectchauffeur.photo
                                                    ? selectchauffeur.photo
                                                    : "Pas de photo"}
                                                </Link>
                                              </h6>
                                            </div>
                                          </div>
                                        </td>

                                        <td>
                                          {selectchauffeur.photo
                                            ? selectchauffeur.photo
                                            : "Pas de date"}
                                        </td>
                                        <td>
                                          <UncontrolledDropdown
                                            direction="start"
                                            disabled={!selectchauffeur.photo}
                                          >
                                            <DropdownToggle
                                              tag="a"
                                              className="btn btn-light btn-icon"
                                              id="dropdownMenuLink15"
                                              role="button"
                                            >
                                              <i className="ri-equalizer-fill"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                              <DropdownItem>
                                                <i className="ri-pencil-fill me-2 align-middle text-muted" />
                                                Modifier
                                              </DropdownItem>
                                              <DropdownItem>
                                                <i className="ri-eye-fill me-2 align-middle text-muted" />
                                                Visualiser
                                              </DropdownItem>
                                              <DropdownItem>
                                                <i className="ri-download-2-fill me-2 align-middle text-muted" />
                                                Télécharger
                                              </DropdownItem>
                                            </DropdownMenu>
                                          </UncontrolledDropdown>
                                        </td>
                                      </tr>

                                      {/* Piece d'identite */}
                                      <tr>
                                        <td>
                                          <div className="d-flex align-items-center">
                                            <div className="avatar-sm">
                                              <div
                                                className={`avatar-title bg-soft-${
                                                  selectchauffeur.piece_identite
                                                    ? "primary"
                                                    : "danger"
                                                } text-${
                                                  selectchauffeur.piece_identite
                                                    ? "primary"
                                                    : "danger"
                                                } rounded fs-20`}
                                              >
                                                <i className="ri-image-2-fill"></i>
                                              </div>
                                            </div>
                                            <div className="ms-3 flex-grow-1">
                                              <h6 className="fs-15 mb-0">
                                                <Link to="#">
                                                  {selectchauffeur.piece_identite
                                                    ? selectchauffeur.piece_identite
                                                    : "Pas de piece d'identite"}
                                                </Link>
                                              </h6>
                                            </div>
                                          </div>
                                        </td>

                                        <td>
                                          {selectchauffeur.piece_identite
                                            ? selectchauffeur.piece_identite
                                            : "Pas de date"}
                                        </td>

                                        <td>
                                          <UncontrolledDropdown
                                            direction="start"
                                            disabled={
                                              !selectchauffeur.piece_identite
                                            }
                                          >
                                            <DropdownToggle
                                              tag="a"
                                              className="btn btn-light btn-icon"
                                              id="dropdownMenuLink15"
                                              role="button"
                                            >
                                              <i className="ri-equalizer-fill"></i>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                              <DropdownItem>
                                                <i className="ri-pencil-fill me-2 align-middle text-muted" />
                                                Modifier
                                              </DropdownItem>
                                              <DropdownItem>
                                                <i className="ri-eye-fill me-2 align-middle text-muted" />
                                                Visualiser
                                              </DropdownItem>
                                              <DropdownItem>
                                                <i className="ri-download-2-fill me-2 align-middle text-muted" />
                                                Télécharger
                                              </DropdownItem>
                                            </DropdownMenu>
                                          </UncontrolledDropdown>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </>
                              ) : (
                                <>
                                  <div className="text-center my-3">
                                    <Loader style={{ color: "#014c94" }} />
                                  </div>
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </TabPane>
                </TabContent>
              </div>
            </Col>
          </Row>
        </Container>

        <Modal id="showModal" style={{ maxWidth: 800 }} isOpen={modal} centered>
          <ModalHeader className="bg-soft-info p-3">
            {isEditPhone
              ? props.t("Modifier le numero")
              : props.t("Modifier Chauffeur")}
          </ModalHeader>

          <Form
            onSubmit={async (e) => {
              e.preventDefault();
              validation.handleSubmit();
                    setModal(false);
                   await fetchDataDetail();
            }}
          >
            <ModalBody>
              <Input type="hidden" id="id-field" />
              <Row className="g-3">
                {!isEditPhone && (
                  <>
                    <Col lg={4}>
                      <div>
                        <Label htmlFor="last_name" className="form-label">
                          {props.t("Last Name")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          name="last_name"
                          id="last_name"
                          className="form-control"
                          placeholder={props.t("Entrez le nom")}
                          type="text"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.last_name || ""}
                          invalid={
                            validation.touched.last_name &&
                            validation.errors.last_name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.last_name &&
                        validation.errors.last_name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.last_name}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div>
                        <Label htmlFor="first_name" className="form-label">
                          {props.t("First Name")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          name="first_name"
                          id="first_name"
                          className="form-control"
                          placeholder={props.t("Entrez les prénoms")}
                          type="text"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.first_name || ""}
                          invalid={
                            validation.touched.first_name &&
                            validation.errors.first_name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.first_name &&
                        validation.errors.first_name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.first_name}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div>
                        <Label htmlFor="email" className="form-label">
                          {props.t("Email")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          name="email"
                          id="email"
                          className="form-control"
                          placeholder={props.t("Entrez l'email")}
                          type="email"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                  </>
                )}

                <Col lg={4}>
                  <div>
                    <Label htmlFor="telephone" className="form-label">
                      {props.t("Numéro de téléphone")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </Label>
                    <Input
                      name="telephone"
                      id="telephone"
                      className="form-control"
                      placeholder={props.t("Entrez le numéro de téléphone")}
                      type="text"
                      validate={{
                        required: { value: true },
                      }}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.telephone || ""}
                      invalid={
                        validation.touched.telephone &&
                        validation.errors.telephone
                          ? true
                          : false
                      }
                    />
                    {validation.touched.telephone &&
                    validation.errors.telephone ? (
                      <FormFeedback type="invalid">
                        {validation.errors.telephone}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col>

                {!isEditPhone && (
                  <>
                    <Col lg={4}>
                      <div>
                        <Label htmlFor="type_conducteur" className="form-label">
                          {props.t("Type conducteur")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          name="type_conducteur"
                          id="type_conducteur"
                          className="form-control"
                          readOnly
                          placeholder={props.t("Entrez le type conducteur")}
                          type="text"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={
                            validation.values.type_conducteur || "Conducteur"
                          }
                          invalid={
                            validation.touched.type_conducteur &&
                            validation.errors.type_conducteur
                              ? true
                              : false
                          }
                        />
                        {validation.touched.type_conducteur &&
                        validation.errors.type_conducteur ? (
                          <FormFeedback type="invalid">
                            {validation.errors.type_conducteur}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div>
                        <Label htmlFor="code_parrain" className="form-label">
                          {props.t("Code de parainnage")}
                        </Label>
                        <Input
                          name="code_parrain"
                          id="code_parrain"
                          className="form-control"
                          placeholder={props.t("Entrez le code de parainnage")}
                          type="text"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.code_parrain || ""}
                          invalid={
                            validation.touched.code_parrain &&
                            validation.errors.code_parrain
                              ? true
                              : false
                          }
                        />
                        {validation.touched.code_parrain &&
                        validation.errors.code_parrain ? (
                          <FormFeedback type="invalid">
                            {validation.errors.code_parrain}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div>
                        <Label className="form-label" htmlFor="cg">
                          {props.t("Numero de la carte Grise")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          type="text"
                          className="form"
                          id="cg"
                          name="cg"
                          value={validation.values.cg || ""}
                          // value={validation.values.piece_identite || ""}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                          invalid={
                            validation.errors.cg && validation.touched.cg
                              ? true
                              : false
                          }
                        />
                        {validation.errors.cg && validation.touched.cg ? (
                          <FormFeedback type="invalid">
                            {props.t(validation.errors.cg)}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div>
                        <Label htmlFor="password" className="form-label">
                          {props.t("Mot de passe")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          name="password"
                          id="password"
                          className="form-control"
                          placeholder={props.t("Entrez le mot de passe")}
                          type="text"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.password || ""}
                          invalid={
                            validation.touched.password &&
                            validation.errors.password
                              ? true
                              : false
                          }
                        />
                        {validation.touched.password &&
                        validation.errors.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </Col>
                  </>
                )}
              </Row>
            </ModalBody>
            <ModalFooter>
              <div className="hstack gap-2 justify-content-end">
                <Button
                  type="button"
                  onClick={async () => {
                    setModal(false);
                   await fetchDataDetail();
                  }}
                  className="btn-light"
                >
                  {props.t("Fermer")}
                </Button>

                {/* <button type="button" className="btn btn-light" onClick={() => { setModal(false);dispatch(onGetChauffeurs); }} > {props.t("Fermer")} </button> */}
                <Button
                  type="submit"
                  className="btn"
                  style={{ background: "#002437", color: "white" }}
                  id="update-btn"
                >
                  {isEditPhone
                    ? props.t("Edit")
                    : props.t("Modifier Chauffeur")}
                </Button>
              </div>
            </ModalFooter>
          </Form>
        </Modal>

        <ToastContainer closeButton={false} />
      </div>
    </React.Fragment>
  );
};

ChauffeursDetail.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(ChauffeursDetail));
